import React from 'react';
import PropTypes from 'prop-types';

export default class LoadingStatus extends React.Component {
  render() {
    const statuses =
      typeof this.props.status === 'string' || this.props.status instanceof String
        ? [this.props.status]
        : this.props.status;

    const allDone = statuses.every((status) => status === 'DONE');
    const someError = statuses.some((status) => status === 'ERROR');

    if (someError) {
      return this.props.renderError();
    }

    if (allDone) {
      return this.props.children();
    }

    return this.props.renderLoader();
  }
}

LoadingStatus.defaultProps = {
  renderError: () => (
    <div>Es ist ein Fehler aufgetreten. Bitte versuchen Sie es zu einen späteren Zeitpunkt nochmal.</div>
  ),
  renderLoader: () => <span className="fa fa-spinner fa-spin font-xl padding-xl" />,
};

LoadingStatus.propTypes = {
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired, // Array or String
  renderError: PropTypes.func,
  renderLoader: PropTypes.func,
};
